import React from 'react'
import { Container } from '@uswitch/ev-core/react'
import EmbeddedVideo from '../trustyle-embedded-video'

export default ({ useContainer = false, ...props }) => {
  return useContainer ? (
    <Container>
      <EmbeddedVideo {...props} />
    </Container>
  ) : (
    <EmbeddedVideo {...props} />
  )
}
